module.exports = __webpack_public_path__ + "static/img/fish28.d1a2816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish28.png
// module id = MaSD
// module chunks = 0